import type { LucideIcon } from "lucide-react";

export function EmptyState({
	icon: Icon,
	title,
	description,
	"data-component": dataComponent,
}: {
	icon: LucideIcon;
	title: string;
	description?: string;
	"data-component"?: string;
}) {
	return (
		<div
			data-component={dataComponent}
			className="flex flex-col items-center justify-center gap-3 px-5 py-14 text-center"
		>
			<span className="mb-1 grid size-14 place-items-center rounded-lg bg-primary-soft text-primary">
				<Icon className="size-6" />
			</span>

			<p className="text-base font-semibold text-foreground">{title}</p>

			{!!description && (
				<p className="max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>
			)}
		</div>
	);
}
